import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { useTranslations } from 'next-intl';
import { NotificationDetailsProps } from '../types';
import { NotificationCardContent } from '../components/notification-card-content/notification-card-content';
import {
  Conditional,
  NotificationNoResultBanner,
  useBreakpoint
} from '@cat-ecom/pcc-components';
import NotificationCardHeader from '../components/notification-card-header/notification-card-header';
import NotificationCardFooter from '../components/notification-card-footer/notification-card-footer';
import { NotificationDetailsContainer } from './notification-details-container';
import styles from './notification-details.module.scss';
import { PAGE_BREAKPOINTS } from 'constants/common';

export const NotificationDetails = ({
  notificationData,
  isIAUser,
  defaultDealer,
  storeAddress,
  handleRefresh,
  filterDrawer
}: NotificationDetailsProps) => {
  const t = useTranslations();
  const dcnList = useMemo(() => {
    return defaultDealer ? defaultDealer.customerNumbersInfo : [];
  }, [defaultDealer]);
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);

  return (
    <Conditional
      test={notificationData.length > 0}
      fallback={
        <div className="m-3">
          <NotificationNoResultBanner
            adjustButton
            adjustButtonText={t('ADJUST_FILTERS')}
            noResultText={t('CAL_NO_ORDERS_ERROR')}
            handleFilterDrawer={filterDrawer.initiatorProps}
            notificationVariant="error"
            isMD={isMD}
          />
        </div>
      }
    >
      {notificationData.slice(0).map((item) => (
        <NotificationDetailsContainer
          key={`${item?.notificationId}_${item.orderStatus}_${
            item?.orderNumber
          } ${uuid()}`}
          item={item}
        >
          <NotificationCardHeader
            notification={item}
            hoverClass={styles['order-status']}
            handleRefresh={handleRefresh}
          />
          <NotificationCardContent
            notification={item}
            dcnListLength={dcnList.length}
            isIAUser={isIAUser}
          />
          <NotificationCardFooter
            notification={item}
            storeAddress={storeAddress}
          />
        </NotificationDetailsContainer>
      ))}
    </Conditional>
  );
};
